// 通过url下载文件
export const downloadByUrl = (url: string, filename: string = 'download') => {
  const link = document.createElement('a');
  link.download = filename;
  link.href = `/api-file/api/file/download?url=${encodeURIComponent(url)}`;
  console.log(link.href);
  link.click();
};

// 通过blob下载文件
export const downloadByBlob = (data: Blob, filename: string = 'download') => {
  const dom = document.createElement('a');
  const url = window.URL.createObjectURL(data);
  dom.href = url;
  dom.download = decodeURI(filename);
  dom.style.display = 'none';
  document.body.appendChild(dom);
  dom.click();
  document.body.removeChild(dom);
  window.URL.revokeObjectURL(url);
};
